/**
 * Протокол Fleet Console.
 *
 * Одни и те же типы используют:
 *  - apps/server  — контрольный сервер,
 *  - apps/web     — веб-консоль,
 *  - agent/*.ps1  — агент на Windows (по этим же именам полей формирует JSON).
 *
 * Значения на проводе — английские идентификаторы; русские подписи живут в UI.
 */
export const PROTOCOL_VERSION = 1;
/* ─────────────────────────── Утилиты ─────────────────────────── */
/** Русская плюрализация: plural(2, ['хост','хоста','хостов']) → «2 хоста» */
export function plural(n, forms) {
    const a = Math.abs(n) % 100;
    const b = a % 10;
    if (a > 10 && a < 20)
        return n + ' ' + forms[2];
    if (b > 1 && b < 5)
        return n + ' ' + forms[1];
    if (b === 1)
        return n + ' ' + forms[0];
    return n + ' ' + forms[2];
}
export const HOSTS_FORMS = ['хост', 'хоста', 'хостов'];
export const SERVERS_FORMS = ['сервер', 'сервера', 'серверов'];
export const ERRORS_FORMS = ['ошибка', 'ошибки', 'ошибок'];
export const ON_HOSTS_FORMS = ['хосте', 'хостах', 'хостах'];
/** Состояние хоста по метрикам и порогам — общая логика сервера и UI. */
export function deriveState(m, online) {
    if (!online)
        return 'offline';
    if (m.temp > 82 || m.cpu >= 88)
        return 'warn';
    return 'online';
}
//# sourceMappingURL=index.js.map